import { render, staticRenderFns } from "./FichaClinicaContainer.vue?vue&type=template&id=1c50fde8&scoped=true&"
import script from "./FichaClinicaContainer.vue?vue&type=script&lang=js&"
export * from "./FichaClinicaContainer.vue?vue&type=script&lang=js&"
import style0 from "./FichaClinicaContainer.vue?vue&type=style&index=0&id=1c50fde8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c50fde8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow,VSpacer})
